<template>
  <div class="category-fields-wrapper">
    <el-row>
      <el-col
        v-for="atType in attributeValues"
        :key="atType.key"
        :sm="11"
      >
        <span class="title">{{ $t('category.popup.field.' + atType.key) }}</span>
        <el-input-number
          v-if="atType.type === 'range'"
          v-model="values[atType.id]"
          :min="Number(atType.type_data_parsed.min)"
          :max="Number(atType.type_data_parsed.max)"
          @change="getSelected()"
        />
        <select-primary-js
          v-if="atType.type === 'list'"
          v-model="values[atType.id]"
          class="selector-input"
          :class="locale | rtlTextClass"
          item-key="value"
          item-name="name"
          item-value="value"
          :options="getOptions(atType)"
          @change="onChange(atType)"
        />
      </el-col>
    </el-row>
  </div>
  <!--<el-tabs class="makes-tab" tab-position="left">-->
  <!--<el-tab-pane v-for="make in makes" :label="make.name">-->
  <!--<el-col :sm="8" class="model" v-for="model in make.models">-->
  <!--<el-button @click="[getSelected(category.name, model),category = null, outerVisible = false, innerVisible = false ]">{{model}}</el-button>-->
  <!--</el-col>-->
  <!--</el-tab-pane>-->
  <!--</el-tabs>-->
</template>

<script>
import { mapState } from 'vuex';
import { isEmpty } from '@fps/vue-toolkit/dist/util';
import SelectPrimaryJs from '@/components/MainLeftFilters/SelectPrimaryJs';
import { getFillableAttributeTypes } from '@/store/filters/filters.getters';
import get from 'lodash-es/get';

export default {
  name: 'CategoryFields',
  components: { SelectPrimaryJs },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Object,
      default: null
    },
    subcategory: {
      type: Object,
      default: null
    },
  },

  data() {
    return {
      values: {},
    };
  },

  computed: {
    ...mapState({
      locale: state => state.locale,
    }),
    attributeTypes: {
      get() {
        const category = this.category;
        const subcategory = this.subcategory;
        return getFillableAttributeTypes({ category, subcategory });
      },
    },
    attributeValues: {
      get() {
        return this.attributeTypes;
      },
    },
  },

  watch: {
    value(val) {
      this.valueChange(val);
    },
    category() {
      this.getSelected();
    },
    subcategory() {
      this.getSelected();
    },
  },

  mounted() {
    if (this.value) {
      this.valueChange(this.value);
    }
  },

  methods: {
    checkEmptyAttribute(atValue, atType) {
      switch (atType.type) {
        case 'list': return !atValue || isEmpty(atValue.value);
        case 'range':
        default: return isEmpty(atValue);
      }
    },

    getSelected() {
      const value = Object.keys(this.values)
        .filter(key =>
          this.attributeTypes.find(atType => Number(atType.id) === Number(key) &&
            (!this.checkEmptyAttribute(this.values[key], atType))),
        )
        .map(key => ({
          attribute_type_id: key,
          parent_key: this.values[key] && this.values[key].parent ?
            this.values[key].parent
            : null,
          value: this.values[key] && this.values[key].value ?
            this.values[key].value :
            this.values[key],
        }));

      this.$emit('input', [...value]);
      this.$emit('change', [...value]);
    },

    valueChange(newValue) {
      if (newValue) {
        newValue.forEach((currentValue) => {
          const atType = this.attributeTypes
            .find(item => Number(item.id) === Number(currentValue.attribute_type_id));

          if (atType) {
            switch (atType.type) {
              case 'list':
                if (
                  !this.values[atType.id]
                  ||
                  this.values[atType.id].value !== currentValue.value
                ) {
                  this.values[atType.id] = atType.type_data_parsed
                    .filter(item => item.value === currentValue.value)[0];
                }
                break;
              case 'range':
              default:
                if (!this.values[atType.id] || this.values[atType.id] !== currentValue.value) {
                  this.values[atType.id] = currentValue.value;
                }
            }
          }
        });
      }
    },

    onChange(type) {
      this.attributeValues
        .filter(itemType => itemType.parent_key === type.key)
        .forEach((item) => {
          this.$delete(this.values, item.id);
        });
      this.getSelected();
    },

    getOptions(type) {
      const options = get(type, 'type_data_parsed', []);

      if (!type.parent_key) {
        return options;
      }

      const parentType = this.attributeValues.find(item => item.key === type.parent_key);
      const parentValue = this.values[parentType.id];

      if (parentType && parentValue) {
        return options.filter(item => item.parent === parentValue.value);
      }

      return options;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CategoryPopup/CategoryFields.vue